import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Ripple } from 'primereact/ripple';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Service } from "../../../service/Service";
import { BITACORA_POST_TABLE_FILTER, BITACORA_POST_FILTER, BITACORA_REPORTE } from "../../../genericos/Uris";
import Spinner from '../../../components/loader/Spinner';
import DialogCustom from "./DialogCustom";
import { Toast } from 'primereact/toast';
import TituloComponent from '../../../genericos/TituloComponent';
import ErrorSistema from '../../../components/error/ErrorSistema';
import moment from 'moment';


const BitacoraTbl = () => {

    const servicioBitacora = new Service();
    //--> Variables para el paginado
    const [currentPage, setCurrentPage] = useState(1);
    const [pageInputTooltip, setPageInputTooltip] = useState('Press \'Enter\' key to go to this page.');
    const [first1, setFirst1] = useState(0);
    // const [rowsTbl, setRowsTbl] = useState(5);
    const [loading, setLoading] = useState(true);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [filtros, setFiltros] = useState({});
    const [bitacoraList, setBitacoraList] = useState([]);
    const [isReport, setIsReport] = useState(false);
    const [mensaje, setMensaje] = useState("");

    const [totalRecords, setTotalRecords] = useState(0);
    const [fechaIncAux, setFechaIncAux] = useState();
    const [fechaFinAux, setFechaFinAux] = useState();
    const [idPlanta, setIdPlanta] = useState();

    const [dialog, setDialog] = useState(false);
    const [lazyParams, setLazyParams] = useState({
        first: 1,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        filters: {
            'accion': { value: '', matchMode: 'contains' },
            'modulo': { value: '', matchMode: 'contains' },
            'creadoPor': { value: '', matchMode: 'contains' },
            'fechaCreacion': { value: '', matchMode: 'contains' }
        },
        fechaInc: null,
        fechaFin: null,
        idPlanta: null
    });
    const [error, setError] = useState(null);
    const toast = useRef(null);

    function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
    }


    useEffect(() => {
        if (!isObjectEmpty(filtros)) setIsReport(true)
    }, [filtros])


    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const enviarFiltro = async (request) => {

        if (request.fechaInicio === null || request.fechaFin === null) {
            setMensaje("Todos los campos son obligatorios");
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (new Date(request.fechaFin).getTime() < new Date(request.fechaInicio).getTime()) {
            setMensaje("La fecha de inicio es mayor que la fecha fin.")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (new Date(request.fechaFin).getTime() === new Date(request.fechaInicio).getTime()) {
            setMensaje('Fecha inicio y fecha fin no pueden ser iguales.')
            setTimeout(() => { setMensaje('') }, 3000);
            return
        }
        const fechaInicio_ = moment(request.fechaInicio).format('YYYY-MM-DD HH:mm:ss');
        const fechaFin_ = moment(request.fechaFin).format('YYYY-MM-DD HH:mm:ss');

        setLoading(true)
        setFiltros({ fechaInicioP: fechaInicio_, fechaFinP: fechaFin_, idPlantaP: request.idPlanta })
        if (Object.values(request).includes(undefined) || request.fechaInicio.length === 0 || request.fechaFin.length === 0) {
            setMensaje("Todos los campos son obligatorios")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        setFechaIncAux(fechaInicio_)
        setFechaFinAux(fechaFin_)

        let bodyBitacora = {
            "page": 0,
            "total": 10,
            "fechaInc": fechaInicio_,
            "fechaFin": fechaFin_,
            "idPlanta": request.idPlanta

        }
        servicioBitacora.baseUrl = servicioBitacora.baseUrl + BITACORA_POST_FILTER
        if (!(request.from === "button")) {
            bodyBitacora.page = request.page
            bodyBitacora.total = request.rows
        }
        try {
            const data = await servicioBitacora.create(bodyBitacora)
            getBitacora(data)
        }
        catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
        setDialog(false)
    }

    const loadLazyData = async () => {
        setLoadingFilter(true)
        lazyParams.fechaInc = fechaIncAux;
        lazyParams.fechaFin = fechaFinAux;
        lazyParams.idPlanta = idPlanta;
        setError(null)
        try {
            servicioBitacora.baseUrl = servicioBitacora.baseUrl + BITACORA_POST_TABLE_FILTER
            const JSobj = JSON.parse(JSON.stringify(lazyParams));
            const data = await servicioBitacora.create(JSobj);
            getBitacora(data)
            setLoadingFilter(false)
        }
        catch (error) {
            setError(error.message)
            setLoadingFilter(false)
            setLoading(false)
        } finally {
            setLoading(false)
            setLoading(false)
            setLoadingFilter(false)
        }
    }

    const onPage = (event) => {
        console.log("onPage")
        setLazyParams(event);
    }

    const onSort = (event) => {
        console.log("on sort")
        setLazyParams(event);
    }

    const onFilter = (event) => {
        console.log("on filter")
        event['first'] = 0;
        setLazyParams(event);
    }

    const getBitacora = (data) => {
        setBitacoraList([]);
        if (data.bitacora != null) {
            data.bitacora.forEach(element => {
                setBitacoraList(oldArray => [...oldArray,
                {
                    accion: element.accion, creadoPor: element.creadoPor, modulo: element.modulo, fechaCreacion: element.fechaCreacion
                }]);
            });
            setTotalRecords(data.numTotalReg);
        } else { console.log('no se encontran registros') }
        setLoading(false)
    }
    // console.log(bitacoraList)

    const template1 = {

        layout: 'PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport LastPage',

        'PrevPageLink': (options) => {
            return (
                <div className="flex-wrap w-full text-center md:flex md:w-auto md:text-right">
                    <div className="mt-3">
                        <Button icon="pi pi-angle-double-left" onClick={goFirst} style={{ height: '10px' }} />
                    </div>
                    <div>
                        <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
                            <span className="p-3">Previo</span>
                            <Ripple />
                        </button>
                    </div>
                </div>
            )
        },

        'NextPageLink': (options) => {
            return (
                <div className="w-full md:w-auto text-center">
                    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
                        <span className="p-3">Siguiente</span>
                        <Ripple />
                    </button>
                </div>
            )
        },

        'PageLinks': (options) => {
            if ((options.view.startPage === options.page && options.view.startPage !== 0) || (options.view.endPage === options.page && options.page + 1 !== options.totalPages)) {
                const className = classNames(options.className, { 'p-disabled': true });
                return <span className={className} style={{ userSelect: 'none' }}>...</span>;
            }
            return (
                <>
                    <button type="button" className={options.className} onClick={options.onClick}>
                        {options.page + 1}
                        <Ripple />
                    </button>
                </>
            )
        },

        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 25, value: 25 },
            ];
            return (
                <div className='text-center w-full md:w-auto'>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </div>
            );
        },

        'CurrentPageReport': (options) => {
            return (
                <div className="mt-3 md:mt-3 md:flex">
                    <div className="md:flex">
                        <p className="w-full md:w-auto">
                            <span className="mx-3" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                                Ir a <InputText size="2" className="ml-1" value={currentPage} tooltip={pageInputTooltip}
                                    onKeyDown={(e) => onPageInputKeyDown(e, options)} onChange={onPageInputChange} />
                            </span>
                        </p>
                        <p className="w-full md:w-auto md:mt-3 text-center mb-2 md:mb-0">
                            Página {options.currentPage} de {options.totalPages}
                        </p>
                    </div>
                    <div className="mx-3 md:mt-3 text-center">
                        <Button icon="pi pi-angle-double-right" onClick={() => goEnd(options.totalPages, options.rows)} style={{ height: '10px' }} />
                    </div>
                </div>
            )
        },
    };

    const goEnd = (numPage, rows) => {
        const lazyParamsCopy = lazyParams;
        lazyParamsCopy.first = rows * (numPage - 1);
        lazyParamsCopy.page = numPage - 1;
        setFirst1(lazyParamsCopy.first);
        setCurrentPage(lazyParamsCopy.page);
        setLazyParams(lazyParamsCopy);
        loadLazyData();
    }

    const goFirst = () => {
        const lazyParamsCopy = lazyParams;
        lazyParamsCopy.first = 0;
        lazyParamsCopy.page = 0;
        setFirst1(0);
        setCurrentPage(1);
        setLazyParams(lazyParamsCopy);
        loadLazyData();
    }

    // console.log(lazyParams)

    const onPageInputKeyDown = (event, options) => {
        if (event.key === 'Enter') {
            const pageP = parseInt(currentPage);
            if (pageP < 1 || pageP > options.totalPages) {
                setPageInputTooltip(`Value must be between 1 and ${options.totalPages}.`);
            }
            else {
                const first = currentPage ? options.rows * (pageP - 1) : 0;
                const lazyParamsCopy = lazyParams;
                lazyParamsCopy.first = first;
                lazyParamsCopy.page = pageP;
                setFirst1(first);
                setCurrentPage(pageP);
                setLazyParams(lazyParamsCopy);
                loadLazyData();
                setPageInputTooltip('Press \'Enter\' key                                              to go to this page.');
            }
        }
    }


    const onPageInputChange = (event) => {
        setCurrentPage(event.target.value);
    }

    const exportToExcel = async () => {
        try {
            setLoading(true)
            lazyParams.fechaInc = fechaIncAux;
            lazyParams.fechaFin = fechaFinAux;
            servicioBitacora.baseUrl = servicioBitacora.baseUrl + BITACORA_REPORTE
            const JSobj = JSON.parse(JSON.stringify(lazyParams));
            const data = await servicioBitacora.createReport(JSobj);
            downloadData(data)
            setLoading(false)
            toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${"Tu reporte se generó correctamente."}`, life: 3000 });
        }
        catch (error) {
            setLoading(false)
            setError(error.message)
        }
    }

    const downloadData = (blob) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                const data = new Blob([blob], {
                    type: EXCEL_TYPE,
                });
                module.default.saveAs(data, "Bitacora" + "_export_" + new Date().getTime());
            }
        });
    }


    return (

        <>
            {!loading && !error &&
                (<div>
                    <TituloComponent titulo="Bitácora" />
                    <DialogCustom enviarFiltroP={enviarFiltro} setDialog={setDialog} dialog={dialog} mensaje={mensaje} setMensaje={setMensaje} />
                    <Toast ref={toast} />
                    <div className="bg-white border-round md:flex md:justify-content-between text-center">
                        <div className='mb-3 md:mb-auto'>
                            <Button label="Filtro" icon="pi pi-filter-fill" onClick={() => setDialog(true)} className="col-2 w-min md:w-max" />
                        </div>
                        <div>
                            {isReport ? <Button label="Excel" icon="pi pi-file-excel" className="p-button-success m-4 col-2 w-min md:w-max" onClick={exportToExcel} /> : <></>}
                        </div>
                    </div>

                    {/* <Toolbar className="mb-4 mt-1"  right={rightToolbarTemplate}></Toolbar> */}
                    <div className="card">
                        <DataTable
                            value={bitacoraList}
                            lazy filterDisplay="row" paginator first={lazyParams.first} rows={lazyParams.rows}
                            paginatorTemplate={template1} totalRecords={totalRecords} onPage={onPage} onSort={onSort}
                            sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} onFilter={onFilter}
                            filters={lazyParams.filters}
                            loading={loadingFilter}
                            tableStyle={{ minWidth: '60rem' }}
                            responsiveLayout="scroll"
                            emptyMessage="No se encontraron registros"
                        >
                            <Column align={"center"} style={{ width: '25%' }} field="accion" header="Acción" sortable filter filterPlaceholder="Search" />
                            <Column align={"center"} style={{ width: '25%' }} field="modulo" sortable header="Módulo" filter filterPlaceholder="Search" />
                            <Column align={"center"} style={{ width: '25%' }} field="creadoPor" sortable filter header="Creado Por" filterPlaceholder="Search" />
                            <Column align={"center"} style={{ width: '25%' }} field="fechaCreacion" header="Fecha" sortable filter filterPlaceholder="Search" />
                        </DataTable>
                    </div>
                </div>
                )}

            {loading && <Spinner />}
            {error && <ErrorSistema texto={error} />}
        </>
    );

}

export default BitacoraTbl;



